export function getView(width) {
    let newView = "MobileView";
    if (width >= 1200)
        newView = "DesktopView";
    else if (width >= 768)
        newView = "TabView";

    return newView;
}

export function getGridSize(width) {
    if (width < 576)
        return 'xs';
    if (width < 768)
        return 'sm';
    if (width < 992)
        return 'md';
    if (width < 1200)
        return 'lg';
    if (width < 1600)
        return 'xl';
    return 'xxl';
}

const actions = {
    APP_START_PULLING: 'APP_START_PULLING',
    APP_STOP_PULLING: 'APP_STOP_PULLING',
    APP_START_PUSHING: 'APP_START_PUSHING',
    APP_STOP_PUSHING: 'APP_STOP_PUSHING',

    APP_SET_VERSION: 'APP_SET_VERSION',
    APP_TOGGLE_SESSION_TIMEOUT: 'APP_TOGGLE_SESSION_TIMEOUT',
    START_DRAWER_SET: 'START_DRAWER_SET',
    START_POPOVER_SET: 'START_POPOVER_SET',

    // for sidebar
    SHOEBOX_BADGE_COUNT_ADD: 'SHOEBOX_BADGE_COUNT_ADD',
    SHOEBOX_BADGE_COUNT_RESET: 'SHOEBOX_BADGE_COUNT_RESET',

    // for quota usage
    SHOEBOX_PAGE_COUNT_ADD: 'SHOEBOX_PAGE_COUNT_ADD',
    SHOEBOX_PAGE_COUNT_RESET: 'SHOEBOX_PAGE_COUNT_RESET',
    UNIVERSAL_SMART_RECON_PAGE_COUNT_ADD: 'UNIVERSAL_SMART_RECON_PAGE_COUNT_ADD',
    UNIVERSAL_SMART_RECON_PAGE_COUNT_RESET: 'UNIVERSAL_SMART_RECON_PAGE_COUNT_RESET',

    COLLAPSE_CHANGE: "COLLAPSE_CHANGE",
    COLLAPSE: "COLLAPSE",
    UNCOLLAPSE: "UNCOLLAPSE",
    TOGGLE_DRAWER_FORCED_OPEN: "TOGGLE_DRAWER_FORCED_OPEN",
    CHANGE_OPEN_KEYS: "CHANGE_OPEN_KEYS",
    TOGGLE_ALL: "TOGGLE_ALL",
    CHANGE_CURRENT: "CHANGE_CURRENT",
    CLEAR_MENU: "CLEAR_MENU",
    UPDATE_SETTINGS: "UPDATE_SETTINGS",

    OPEN_INTERCEPTOR: 'OPEN_INTERCEPTOR',
    CLOSE_INTERCEPTOR: 'CLOSE_INTERCEPTOR',

    OPEN_APP_MODAL: 'OPEN_APP_MODAL',
    CLOSE_APP_MODAL: 'CLOSE_APP_MODAL',
    CLOSE_ALL_APP_MODALS: 'CLOSE_ALL_APP_MODALS',

    APP_CHANGE_LOCALE: 'APP_CHANGE_LOCALE',
    APP_SET_LOCALE_LOADED: 'APP_SET_LOCALE_LOADED',
    APP_SET_WEBSOCKET: 'APP_SET_WEBSOCKET',
    APP_SET_DATA_EXTRACTION_CHANNEL: 'APP_SET_DATA_EXTRACTION_CHANNEL',
    APP_SET_RESIZE_EVENT: 'APP_SET_RESIZE_EVENT',

    startPulling: () => ({
        type: actions.APP_START_PULLING,
    }),
    stopPulling: () => ({
        type: actions.APP_STOP_PULLING,
    }),
    startPushing: () => ({
        type: actions.APP_START_PUSHING,
    }),
    stopPushing: () => ({
        type: actions.APP_STOP_PUSHING,
    }),

    setVersion: version => ({
        type: actions.APP_SET_VERSION,
        version,
    }),
    toggleTimeoutBox: visible => ({
        type: actions.APP_TOGGLE_SESSION_TIMEOUT,
        visible,
    }),
    startDrawerSet: visible => ({
        type: actions.START_DRAWER_SET,
        visible,
    }),
    startPopoverSet: visible => ({
        type: actions.START_POPOVER_SET,
        visible,
    }),
    shoeboxBadgeCountAdd: () => ({
        type: actions.SHOEBOX_BADGE_COUNT_ADD,
    }),
    shoeboxBadgeCountReset: () => ({
        type: actions.SHOEBOX_BADGE_COUNT_RESET,
    }),
    shoeboxPageCountAdd: count => ({
        type: actions.SHOEBOX_PAGE_COUNT_ADD,
        count,
    }),
    shoeboxPageCountReset: () => ({
        type: actions.SHOEBOX_PAGE_COUNT_RESET,
    }),
    universalSmartReconPageCountAdd: count => ({
        type: actions.UNIVERSAL_SMART_RECON_PAGE_COUNT_ADD,
        count,
    }),
    universalSmartReconPageCountReset: () => ({
        type: actions.UNIVERSAL_SMART_RECON_PAGE_COUNT_RESET,
    }),
    toggleCollapsed: () => ({
        type: actions.COLLAPSE_CHANGE,
    }),
    collapse: () => ({
        type: actions.COLLAPSE,
    }),
    uncollapse: () => ({
        type: actions.UNCOLLAPSE,
    }),
    toggleAll: width => {
        const view = getView(width);
        const gridSize = getGridSize(width);
        const drawerCollapsedMode = view !== "DesktopView";
        return {
            type: actions.TOGGLE_ALL,
            drawerCollapsedMode,
            view,
            width,
            gridSize,
        };
    },
    toggleDrawerOpen: forceState => ({
        type: actions.TOGGLE_DRAWER_FORCED_OPEN,
        forceState,
    }),
    changeOpenKeys: openKeys => ({
        type: actions.CHANGE_OPEN_KEYS,
        openKeys,
    }),
    changeCurrent: current => ({
        type: actions.CHANGE_CURRENT,
        current,
    }),
    clearMenu: () => ({
        type: actions.CLEAR_MENU,
    }),
    updateSettings: settings => ({
        type: actions.UPDATE_SETTINGS,
        settings,
    }),

    closeInterceptor: () => ({
        type: actions.CLOSE_INTERCEPTOR,
    }),

    changeLocale: locale => ({
        type: actions.APP_CHANGE_LOCALE,
        locale,
    }),
    setLocaleLoaded: localeLoaded => ({
        type: actions.APP_SET_LOCALE_LOADED,
        localeLoaded,
    }),
    setWebsocket: websocket => ({
        type: actions.APP_SET_WEBSOCKET,
        websocket,
    }),
    setDataExtractionChannel: channel => ({
        type: actions.APP_SET_DATA_EXTRACTION_CHANNEL,
        channel,
    }),
    openAppModal: modalType => ({
        type: actions.OPEN_APP_MODAL,
        modalType,
    }),
    closeAppModal: modalType => ({
        type: actions.CLOSE_APP_MODAL,
        modalType,
    }),
    closeAllAppModals: () => ({
        type: actions.CLOSE_ALL_APP_MODALS,
    }),
};
export default actions;
